import {lazy, useEffect, useState} from 'react';
import { useRoutes } from 'react-router-dom';

// project import
import CommonLayout from 'layout/website/mantis';
import Loadable from 'layout/mantis/components/Loadable';
import AuthGuard from 'layout/mantis/utils/route-guard/AuthGuard';
import MainLayout from 'layout/app/mantis';

import LoginRoutes from './LoginRoutes';

import MainRoutes from './MainRoutes';
import {useLocation} from "react-router";

// render - landing page
const PagesLanding = Loadable(lazy(() => import('modules/website/landing/Landing')));

const DashboardDefault = Loadable(lazy(() => import('modules/dashboard/default')));

// ==============================|| ROUTING RENDER ||============================== //

export default function AppRoutes() {
    return useRoutes([
        // {
        //     path: '/',
        //     element: <CommonLayout layout="landing"/>,
        //     children: [
        //         {
        //             path: '/',
        //             element: <PagesLanding/>
        //         }
        //     ]
        // },
        {
            path: '/',
            element: (
                <AuthGuard>
                    <MainLayout />
                </AuthGuard>
            ),
            children: [
                {
                    path: '/',
                    element: <DashboardDefault />
                },
            ]
        },
        LoginRoutes,
        MainRoutes
    ]);
}
